import { SUB_TIER } from "../Const";
import { checkSub } from "./SubUtils";

const DEVELOPER_API_TIERS = [SUB_TIER.pro, SUB_TIER.master];
const DEVELOPER_API_PERIODS = ["yearly"];

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const hasValue = (values, allowedValues) =>
  values.some((value) => allowedValues.includes(normalize(value)));

const isEnabled = (value) =>
  value === true || value === 1 || value === "1" || normalize(value) === "true";

const subscriptionValues = (subscription, fallback) => [
  subscription?.tier,
  subscription?.subscription_tier,
  subscription?.plan_tier,
  subscription?.plan,
  subscription?.product_name,
  subscription?.name,
  fallback,
];

const subscriptionPeriodValues = (subscription, fallback) => [
  subscription?.period,
  subscription?.type,
  subscription?.sub_type,
  subscription?.subscription_period,
  subscription?.plan_period,
  subscription?.billing_period,
  subscription?.billing_interval,
  subscription?.interval,
  subscription?.plan,
  subscription?.product_name,
  subscription?.name,
  fallback,
];

export const canAccessDeveloperApiSubscription = (subscription) => {
  const { subPremium, subTier, subType } = checkSub(subscription);
  if (!subPremium) return false;

  if (isEnabled(subscription?.api_access_enabled)) return true;

  const tierValues = subscriptionValues(subscription, subTier);

  return (
    hasValue(tierValues, DEVELOPER_API_TIERS) &&
    hasValue(subscriptionPeriodValues(subscription, subType), DEVELOPER_API_PERIODS)
  );
};

export const canAccessDeveloperApi = (user) =>
  canAccessDeveloperApiSubscription(user?.user_subscription);
